import Alpine from '@alpinejs/csp';
import focus from '@alpinejs/focus';
import '@tailwindplus/elements';
import initSwiper from './components/swiper';
import initNavigation from './components/navigation';
import initVideo from './components/video';
import initCounter from './components/counter';
import initStyles from './components/jsStyles';
import initCopyToClipboard from './components/CopyToClipboard';
import initCookieConsent from './components/cookieConsent';
import initA11yControls from './components/accessibility';

Alpine.plugin(focus);
window.Alpine = Alpine;
const startingWith = (subject: string, replacement: string) => (
  { name, value }: { name: string; value: string },
) => {
  if (name.startsWith(subject)) {
    // eslint-disable-next-line no-param-reassign
    name = name.replace(subject, replacement);
  }
  return { name, value };
};

document.addEventListener('alpine:init', () => {
  Alpine.prefix('data-x-');
  Alpine.mapAttributes(startingWith('data-x-show', Alpine.prefixed('show')));
  Alpine.mapAttributes(startingWith('data-x-on.', Alpine.prefixed('on:')));
  Alpine.mapAttributes(startingWith('data-x-ref', Alpine.prefixed('ref')));
  Alpine.mapAttributes(startingWith('data-x-bind.', Alpine.prefixed('bind:')));
  Alpine.mapAttributes(startingWith('data-x-cloak', Alpine.prefixed('cloak')));
  Alpine.mapAttributes(startingWith('data-x-transition.', Alpine.prefixed('transition:')));
  Alpine.mapAttributes(startingWith('data-x-trap.', Alpine.prefixed('trap')));
  Alpine.mapAttributes(startingWith('data-x-text', Alpine.prefixed('text')));
  Alpine.mapAttributes(startingWith('data-x-init', Alpine.prefixed('init')));
  initCookieConsent();
  initSwiper();
  initNavigation();
  initVideo();
  initCounter();
  initStyles();
  initCopyToClipboard();
  initA11yControls();
});
Alpine.start();
